import React from "react";
const InversifyContext = React.createContext({ container: null });
const InversifyProvider = ({ children, container }) => {
  return /* @__PURE__ */ React.createElement(InversifyContext.Provider, { value: { container } }, children);
};
export {
  InversifyContext,
  InversifyProvider
};
//# sourceMappingURL=inversifyProvider.js.map
